module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAMAAAAMCGV4AAAAhFBMVEUAAABAQIBgYIBqaoBqdYBtdn9zc4RwcIBudIBwdYBwdYJuc39xeYJweIBvd35veIFxd4BxdoFwd4FxeIFyeIFxd4Bwd4Byd4BwdoBweIBvd4Bxd4Bwd4Bxd4BveIBxeIBweIBweIBwd4Bxd4Bwd4Bxd4BweIBxeIBweIBxeIBxd4BxeIBnba5aAAAALHRSTlMABAgMGBwfICwwOzw/QEdXWF9rc3eDi4ubn6enq6u3t7u/w8fLy9Pb39/n9+VYPnsAAAB4SURBVAgdBcEJAoFAAADAaVsS1pGbHKEo//+fGQAAEHfPb3eaA6yH7SSMVu05B+s2AodbhjhE1HCpsNtCD8UXrwn0oC3oM/g1zaNUJ7oRLFJKQVNyWgIIQyC9AWyOcN0Dpp8I+f08Rth8ZkBW9e+6GY4RgCKVAfwBbNkHZT8jXvMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon_clock.png
// module id = Hs4r
// module chunks = 1 4